<template>
  <div class="schedule-option" v-if="isOptionShowing()">
    <div v-if="broadcastingChannels.tv"
      class="schedule-option-item channel-tv">
      <i class="fas fa-tv icon"></i>
    </div>
    <div v-if="broadcastingChannels.web"
      class="schedule-option-item channel-web">
      <i class="fas fa-globe icon"></i>
    </div>
    <div v-if="broadcastingChannels.youtube"
      class="schedule-option-item channel-youtube">
      <i class="fab fa-youtube icon"></i>
    </div>
    <div v-if="broadcastingChannels.facebook"
      class="schedule-option-item channel-facebook">
      <i class="fab fa-facebook-f icon"></i>
    </div>
    <div v-if="broadcastingChannels.twitter"
      class="schedule-option-item channel-facebook">
      <i class="fab fa-twitter icon"></i>
    </div>
    <div v-if="isRerun"
      class="schedule-option-item rerun">
      <i class="fas fa-redo-alt icon"></i>
    </div>
    <div v-if="features.audioDesc"
      class="schedule-option-item audio-desc">
      <i class="fas fa-audio-description"></i>
    </div>
    <div v-if="features.signLanguage"
      class="schedule-option-item sign-language">
      <i class="fas fa-sign-language icon"></i>
    </div>
    <div v-if="features.closedCaptions"
      class="schedule-option-item closed-captions">
      <i class="far fa-closed-captioning icon"></i>
    </div>
    <div v-if="features.soundtrack"
      class="schedule-option-item soundtrack">
      <i class="fas fa-music icon"></i>
    </div>
    <div v-if="features.restrictedLicense"
      class="schedule-option-item restricted-license">
      <i class="fas fa-ban icon"></i>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    isRerun: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Object,
      default: () => {},
    },
    broadcastingChannels: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    isOptionShowing() {
      return !_.isEmpty(this.broadcastingChannels) || !_.isEmpty(this.features);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.schedule-option {
  display: flex;
  margin-top: $spacer * 0.25;
  .schedule-option-item {
    margin-right: $spacer * 0.5;
  }
}
</style>
